<div class="deletion-requests">
  <!-- Header Section -->
  <div class="header-section">
    <h2>{{ 'pages.settings.deletionRequests.title' | transloco }}</h2>
    <p class="description">{{ 'pages.settings.deletionRequests.description' | transloco }}</p>
  </div>

  <!-- Existing Requests Section - Always shown -->
  <div class="existing-requests-section">
    <div class="category-header">
      <h3>{{ 'pages.settings.deletionRequests.existingRequests.title' | transloco }}</h3>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ 'pages.settings.deletionRequests.existingRequests.loading' | transloco }}</p>
    </div>

    <!-- Requests List -->
    <div *ngIf="!isLoading && deletionRequests.length > 0" class="requests-list">
      <div *ngFor="let request of deletionRequests" class="request-item">
        <div class="request-header">
          <div class="request-title">
            <i class="fas {{ getStatusIcon(request.status) }}"></i>
            {{ 'pages.settings.deletionRequests.existingRequests.accountDeletion' | transloco }}
          </div>
          <div class="request-status">
            <mat-chip [color]="getStatusColor(request.status)" highlighted>
              {{ 'pages.settings.deletionRequests.status.' + request.status | transloco }}
            </mat-chip>
          </div>
        </div>

        <div class="request-content">
          <div class="detail-row">
            <span class="label">{{ 'pages.settings.deletionRequests.existingRequests.requestedAt' | transloco }}</span>
            <span class="value">{{ formatDateTime(request.requestedAt) }}</span>
          </div>

          <div class="detail-row" *ngIf="request.processedAt">
            <span class="label">{{ 'pages.settings.deletionRequests.existingRequests.completedAt' | transloco }}</span>
            <span class="value">{{ formatDateTime(request.processedAt) }}</span>
          </div>

          <div class="detail-row">
            <span class="label">{{ 'pages.settings.deletionRequests.existingRequests.verified' | transloco }}</span>
            <span class="value" [class.verified]="request.identityVerifiedAt" [class.not-verified]="!request.identityVerifiedAt">
              <i class="fas" [ngClass]="request.identityVerifiedAt ? 'fa-check-circle' : 'fa-clock'"></i>
              {{ request.identityVerifiedAt ?
                 ('pages.settings.deletionRequests.existingRequests.yes' | transloco) :
                 ('pages.settings.deletionRequests.existingRequests.no' | transloco) }}
            </span>
          </div>
        </div>

        <div *ngIf="canCancelRequest(request)" class="request-actions">
          <button
            mat-button
            color="primary"
            (click)="cancelDeletionRequest(request.id!.toString())">
            <i class="fas fa-times-circle"></i>
            {{ 'pages.settings.deletionRequests.existingRequests.cancel' | transloco }}
          </button>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && deletionRequests.length === 0" class="empty-state">
      <i class="fas fa-inbox"></i>
      <p>{{ 'pages.settings.deletionRequests.existingRequests.empty' | transloco }}</p>
    </div>
  </div>

  <!-- Create Deletion Request Section - Always shown below -->
  <div class="create-request-section">
    <mat-card class="request-card">
      <mat-card-header>
        <mat-card-title>
          <i class="fas fa-trash"></i>
          {{ 'pages.settings.deletionRequests.deleteAccount.title' | transloco }}
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <p>{{ 'pages.settings.deletionRequests.deleteAccount.description' | transloco }}</p>

        <!-- Active Request Warning -->
        <div *ngIf="hasPendingOrProcessingRequest" class="info-notice">
          <i class="fas fa-info-circle"></i>
          <span>{{ 'pages.settings.deletionRequests.deleteAccount.activeRequestWarning' | transloco }}</span>
        </div>

        <!-- Warning Notice (only if no active request) -->
        <div *ngIf="!hasPendingOrProcessingRequest" class="warning-notice">
          <i class="fas fa-exclamation-triangle"></i>
          <span>{{ 'pages.settings.deletionRequests.deleteAccount.warning' | transloco }}</span>
        </div>
      </mat-card-content>

      <mat-card-actions>
        <button
          mat-raised-button
          color="warn"
          (click)="openDeleteAccountModal()"
          [disabled]="hasPendingOrProcessingRequest || isCreatingRequest">
          <i class="fas fa-trash"></i>
          {{ 'pages.settings.deletionRequests.deleteAccount.button' | transloco }}
          <mat-spinner *ngIf="isCreatingRequest" diameter="20" class="button-spinner"></mat-spinner>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
